import * as T from '../types/platform.types';

const PLATFORM_DEFAULT = 'webpush';

export const isSupported = (): boolean => {
  return [
    window.fetch,
    window.navigator.serviceWorker,
    window.Notification,
    window.PushManager,
    window.ServiceWorkerRegistration,
  ].every((item) => typeof item !== 'undefined');
};

export const getBrowser = (): T.IBrowser => {
  const { userAgent } = window.navigator;
  const src =
    userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || [];

  return {
    name: src[1] || '',
    version: src[2] || '',
  };
};

export const isMobile = (): boolean => {
  const { userAgent } = window.navigator;
  const src =
    userAgent.match(
      /(android|blackBerry|iphone|ipad|ipod|opera|iemobile|mobile)/i
    ) || [];

  return src.length > 0;
};

export const getPlatform = (
  overrides: T.IOverrides = {}
): T.IBrowserPlatform => {
  const browser = getBrowser();
  const browserMobile = isMobile();
  const browserLower = browser.name.toLowerCase();

  return {
    BROWSER: {
      IS_MOBILE: browserMobile,
      NAME: overrides[browserLower] ? overrides[browserLower] : browserLower,
      PLATFORM: PLATFORM_DEFAULT,
      VERSION: browser.version,
    },
  };
};

export const getLocation = (): Location => window.location;
